<script>
export default {
  props: ['loading','filters','results','formats'],
  data() {
    return {

    }
  },
  mounted() {
    window.addEventListener('scroll', this.setStickyNav);
    window.addEventListener('resize', this.setStickyNav);
    if(document.querySelector('.table-responsive')) { document.querySelector('.table-responsive').addEventListener('scroll', this.setStickyNav); }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.setStickyNav);
    window.removeEventListener('resize', this.setStickyNav);
    if(document.querySelector('.table-responsive')) { document.querySelector('.table-responsive').removeEventListener('scroll', this.setStickyNav); }
  },
  created() {

  },
  methods: {

  }
}
</script>

<template>
  <div class="table-responsive m-0">
    <table class="table table-small sticky-header table-bordered-right table-hover mb-0 table-centered text-nowrap">
      <thead class="bg-white">
        <tr>
          <th class="font-weight-medium border-top-0">Name</th>
          <th class="font-weight-medium border-top-0">Type</th>
          <th class="font-weight-medium border-top-0">Size</th>
          <th class="font-weight-medium border-top-0">URL</th>
          <th class="font-weight-medium border-top-0">Created on</th>
          <th class="font-weight-medium border-top-0">Options</th>
        </tr>
        <tr class="sticky-thead bg-white">
          <th class="font-weight-medium border-top-0">Name</th>
          <th class="font-weight-medium border-top-0">Type</th>
          <th class="font-weight-medium border-top-0">Size</th>
          <th class="font-weight-medium border-top-0">URL</th>
          <th class="font-weight-medium border-top-0">Created on</th>
          <th class="font-weight-medium border-top-0">Options</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, item_i) in results" :key="item_i">
          <td class="p-1 _c-pointer" @dblclick="$emit('viewfile', item)">
            <div class="d-inline-block align-middle" :style="'background-image: url(' + require('@assets/images/trasnparent-bg.png') + ')'">
              <img v-if="item.type == 'Folder'" class="_w-n-80 _w-m-80 px-2" src="@assets/images/folder-icon.png" >
              <img v-else-if="formats.images.includes(item.type)" class="_w-n-80 _w-m-80" :src="item.url" >
              <img v-else-if="formats.docs.includes(item.type)" class="_w-n-80 _w-m-80 px-2" src="@assets/images/file-icons/doc.svg" >
              <img v-else-if="formats.powerpoints.includes(item.type)" class="_w-n-80 _w-m-80 px-2" src="@assets/images/file-icons/ppt.svg" >
              <img v-else-if="formats.spreadsheets.includes(item.type)" class="_w-n-80 _w-m-80 px-2" src="@assets/images/file-icons/xls.svg" >
              <img v-else-if="formats.archives.includes(item.type)" class="_w-n-80 _w-m-80 px-2" src="@assets/images/file-icons/zip.svg" >
              <img v-else-if="item.type == '3ds'" class="_w-n-80 _w-m-80 px-2" src="@assets/images/file-icons/3ds.svg" >
              <img v-else-if="item.type == 'aac'" class="_w-n-80 _w-m-80 px-2" src="@assets/images/file-icons/aac.svg" >
              <img v-else-if="item.type == 'ai'" class="_w-n-80 _w-m-80 px-2" src="@assets/images/file-icons/ai.svg" >
              <img v-else-if="item.type == 'avi'" class="_w-n-80 _w-m-80 px-2" src="@assets/images/file-icons/avi.svg" >
              <img v-else-if="item.type == 'cad'" class="_w-n-80 _w-m-80 px-2" src="@assets/images/file-icons/cad.svg" >
              <img v-else-if="item.type == 'cdr'" class="_w-n-80 _w-m-80 px-2" src="@assets/images/file-icons/cdr.svg" >
              <img v-else-if="item.type == 'css'" class="_w-n-80 _w-m-80 px-2" src="@assets/images/file-icons/css.svg" >
              <img v-else-if="item.type == 'dat'" class="_w-n-80 _w-m-80 px-2" src="@assets/images/file-icons/dat.svg" >
              <img v-else-if="item.type == 'dll'" class="_w-n-80 _w-m-80 px-2" src="@assets/images/file-icons/dll.svg" >
              <img v-else-if="item.type == 'dmg'" class="_w-n-80 _w-m-80 px-2" src="@assets/images/file-icons/dmg.svg" >
              <img v-else-if="item.type == 'eps'" class="_w-n-80 _w-m-80 px-2" src="@assets/images/file-icons/eps.svg" >
              <img v-else-if="item.type == 'fla'" class="_w-n-80 _w-m-80 px-2" src="@assets/images/file-icons/fla.svg" >
              <img v-else-if="item.type == 'flv'" class="_w-n-80 _w-m-80 px-2" src="@assets/images/file-icons/flv.svg" >
              <img v-else-if="item.type == 'html'" class="_w-n-80 _w-m-80 px-2" src="@assets/images/file-icons/html.svg" >
              <img v-else-if="item.type == 'indd'" class="_w-n-80 _w-m-80 px-2" src="@assets/images/file-icons/indd.svg" >
              <img v-else-if="item.type == 'iso'" class="_w-n-80 _w-m-80 px-2" src="@assets/images/file-icons/iso.svg" >
              <img v-else-if="item.type == 'js'" class="_w-n-80 _w-m-80 px-2" src="@assets/images/file-icons/js.svg" >
              <img v-else-if="item.type == 'midi'" class="_w-n-80 _w-m-80 px-2" src="@assets/images/file-icons/midi.svg" >
              <img v-else-if="item.type == 'mov'" class="_w-n-80 _w-m-80 px-2" src="@assets/images/file-icons/mov.svg" >
              <img v-else-if="item.type == 'mp3'" class="_w-n-80 _w-m-80 px-2" src="@assets/images/file-icons/mp3.svg" >
              <img v-else-if="item.type == 'mpg'" class="_w-n-80 _w-m-80 px-2" src="@assets/images/file-icons/mpg.svg" >
              <img v-else-if="item.type == 'pdf'" class="_w-n-80 _w-m-80 px-2" src="@assets/images/file-icons/pdf.svg" >
              <img v-else-if="item.type == 'php'" class="_w-n-80 _w-m-80 px-2" src="@assets/images/file-icons/php.svg" >
              <img v-else-if="item.type == 'ps'" class="_w-n-80 _w-m-80 px-2" src="@assets/images/file-icons/ps.svg" >
              <img v-else-if="item.type == 'psd'" class="_w-n-80 _w-m-80 px-2" src="@assets/images/file-icons/psd.svg" >
              <img v-else-if="item.type == 'raw'" class="_w-n-80 _w-m-80 px-2" src="@assets/images/file-icons/raw.svg" >
              <img v-else-if="item.type == 'sql'" class="_w-n-80 _w-m-80 px-2" src="@assets/images/file-icons/sql.svg" >
              <img v-else-if="item.type == 'tif'" class="_w-n-80 _w-m-80 px-2" src="@assets/images/file-icons/tif.svg" >
              <img v-else-if="item.type == 'txt'" class="_w-n-80 _w-m-80 px-2" src="@assets/images/file-icons/txt.svg" >
              <img v-else-if="item.type == 'wmv'" class="_w-n-80 _w-m-80 px-2" src="@assets/images/file-icons/wmv.svg" >
              <img v-else-if="item.type == 'xml'" class="_w-n-80 _w-m-80 px-2" src="@assets/images/file-icons/xml.svg" >
            </div>
            <div class="ml-2 d-inline-block align-middle">
              <div class="text-dark font-weight-bold">{{item.name}}</div>
            </div>
          </td>
          <td>{{item.type}}</td>
          <td>{{formatSize(item.size)}}</td>
          <td @click="$emit('copy', item.url)" v-tippy content="Click to copy URL">{{item.url}}</td>
          <td>{{item.date}}</td>
          <td>
            <div class="dropdown">
              <button type="button" class="btn btn-sm btn-white border-0 p-1" data-toggle="dropdown"><Icon icon="ri:more-2-line" /></button>
              <div class="dropdown-menu dropdown-menu-right">
                <a class="dropdown-item _c-pointer" @click="$emit('viewfile', item)">View</a>
                <!-- <a class="dropdown-item _c-pointer">Edit</a> -->
                <a class="dropdown-item _c-pointer" @click="$emit('downloadfiles', item)">Download</a>
                <a v-if="item.type != 'Folder'" class="dropdown-item _c-pointer" @click="$emit('renamefile', item)">Rename</a>
                <a class="dropdown-item _c-pointer" @click="$emit('deletefile', item)">Delete</a>
                <a class="dropdown-item _c-pointer" @click="$emit('viewproperties', item)">Properties</a>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
